"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const formik_1 = require("formik");
const nmr_processing_1 = require("nmr-processing");
const react_1 = require("react");
const generateNumbersPowerOfX_1 = __importDefault(require("../../data/utilities/generateNumbersPowerOfX"));
const DispatchContext_1 = require("../context/DispatchContext");
const ActionButtons_1 = __importDefault(require("../elements/ActionButtons"));
const Label_1 = __importDefault(require("../elements/Label"));
const FormikCheckBox_1 = __importDefault(require("../elements/formik/FormikCheckBox"));
const FormikOnChange_1 = __importDefault(require("../elements/formik/FormikOnChange"));
const FormikSelect_1 = __importDefault(require("../elements/formik/FormikSelect"));
const useFilter_1 = require("../hooks/useFilter");
const useSpectrum_1 = __importDefault(require("../hooks/useSpectrum"));
const Header_1 = require("./Header");
const HeaderContainer_1 = require("./HeaderContainer");
const Sizes = (0, generateNumbersPowerOfX_1.default)(8, 21);
function useInitZeroFillingSize() {
    const filter = (0, useFilter_1.useFilter)(nmr_processing_1.Filters.zeroFilling.id);
    const { data } = (0, useSpectrum_1.default)();
    if (filter) {
        return filter.value.nbPoints;
    }
    else if (data) {
        return 2 ** Math.round(Math.log2(data.x.length * 2));
    }
    return 0;
}
function ZeroFillingOptionsInnerPanel(props) {
    const { size } = props;
    const dispatch = (0, DispatchContext_1.useDispatch)();
    const previousPreviewRef = (0, react_1.useRef)(true);
    function handleApplyFilter(values, triggerSource = 'apply') {
        const { livePreview, ...options } = values;
        switch (triggerSource) {
            case 'onChange': {
                if (livePreview || previousPreviewRef !== livePreview) {
                    dispatch({
                        type: 'CALCULATE_ZERO_FILLING_FILTER',
                        payload: {
                            options,
                            livePreview,
                        },
                    });
                }
                break;
            }
            case 'apply': {
                dispatch({
                    type: 'APPLY_ZERO_FILLING_FILTER',
                    payload: {
                        options,
                    },
                });
                break;
            }
            default:
                break;
        }
        previousPreviewRef.current = livePreview;
    }
    function handleCancelFilter() {
        dispatch({
            type: 'RESET_SELECTED_TOOL',
        });
    }
    return ((0, jsx_runtime_1.jsx)(HeaderContainer_1.HeaderContainer, { children: (0, jsx_runtime_1.jsx)(formik_1.Formik, { onSubmit: (values) => handleApplyFilter(values), initialValues: { nbPoints: size, livePreview: true }, children: ({ submitForm }) => ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Label_1.default, { title: "Size:  ", style: Header_1.headerLabelStyle, children: (0, jsx_runtime_1.jsx)(FormikSelect_1.default, { items: Sizes, style: { marginLeft: 10, marginRight: 10 }, name: "nbPoints" }) }), (0, jsx_runtime_1.jsx)(Label_1.default, { title: "Live preview ", htmlFor: "livePreview", style: { label: { padding: '0 5px' } }, children: (0, jsx_runtime_1.jsx)(FormikCheckBox_1.default, { name: "livePreview" }) }), (0, jsx_runtime_1.jsx)(FormikOnChange_1.default, { onChange: (values) => handleApplyFilter(values, 'onChange'), enableOnload: true }), (0, jsx_runtime_1.jsx)(ActionButtons_1.default, { onDone: submitForm, onCancel: handleCancelFilter })] })) }) }));
}
const MemoizedZeroFillingOptionsPanel = (0, react_1.memo)(ZeroFillingOptionsInnerPanel);
function ZeroFillingOptionsPanel() {
    const size = useInitZeroFillingSize();
    return (0, jsx_runtime_1.jsx)(MemoizedZeroFillingOptionsPanel, { size: size });
}
exports.default = ZeroFillingOptionsPanel;
